module.exports = __webpack_public_path__ + "fonts/NunitoSans-Italic.69d3465.woff";